import { UnstyledButton, Anchor } from '@mantine/core';
import { NavLink } from 'react-router-dom';

import classes from './index.module.css';

interface INavigationLink {
  path: string;
  label: string;
  highlight?: boolean;
  onClick?: () => void;
  onNavigate: () => void;
  preventNavigation?: boolean;
}

const NavigationLink = ({
  path,
  label,
  highlight,
  onClick,
}: INavigationLink) => {
  return (
    <UnstyledButton
      className={`${classes.navButton} ${highlight ? classes.highlight : ''}`}
      onClick={onClick}
    >
      {onClick ? (
        <Anchor underline='never'>{label}</Anchor>
      ) : (
        <NavLink
          to={path}
          className={({ isActive }) => (isActive ? classes.active : undefined)}
          end
        >
          {label}
        </NavLink>
      )}
    </UnstyledButton>
  );
}

export default NavigationLink;